export * from "./clusteredLightContainer";
export * from "./clusteredLightingSceneComponent";

import "../../Shaders/lightProxy.fragment";
import "../../Shaders/lightProxy.vertex";
import "../../ShadersWGSL/lightProxy.fragment";
import "../../ShadersWGSL/lightProxy.vertex";
